import moize from "moize";

export const clearMoizeCache = () => {
        const memoized = moize((item) => {
                return item;
                });
        memoized.clear();       
}